import script from "./ShareholderTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderTrade.vue?vue&type=script&setup=true&lang=js"

import "./ShareholderTrade.vue?vue&type=style&index=0&id=b9e5e762&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e5e762"]])

export default __exports__